import { IApiError } from '@/models/apiError.model';
import { TGetImportsQuery } from '../helpers';
import { IPagination } from '@/models/pagination.model';
import { IProductsImportItem } from '@/models/productsImport.model';

export const PRODUCTS_IMPORT_SLICE_NAME = 'productsImport';

export interface ProductsImportState {
  isLoading: boolean;
  importsList: {
    data: IProductsImportItem[];
    meta: IPagination;
  } | null;
  importsFilters: TGetImportsQuery | null;
  error: IApiError | null;
}

export const initialState: ProductsImportState = {
  isLoading: false,
  importsList: null,
  importsFilters: null,
  error: null,
};
